import type { SelectOption } from "@design";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { type BrandRef, listBrandsOptions } from "@/api";

/** The "None" option's value: the form holds "" and saves null. */
export const NO_BRAND = "";

/**
 * Options for a "Default brand" select (spaces, agents): None (the company
 * default), then the brands the user can see. The current choice is kept even
 * when it isn't in the list, so the select never shows it as blank.
 */
export function useDefaultBrandOptions(current?: BrandRef | null, enabled = true): SelectOption[] {
  const { t } = useTranslation("brands");
  const brands = useQuery({
    ...listBrandsOptions({ query: { page_size: 100 } }),
    enabled,
    select: (r) => r.data.map((b) => ({ value: b.uuid, label: b.name })),
  });
  const list = brands.data ?? [];
  const missing =
    current && !list.some((b) => b.value === current.uuid) ? [{ value: current.uuid, label: current.name }] : [];
  return [{ value: NO_BRAND, label: t("defaultBrand.none") }, ...missing, ...list];
}
